// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rzN1","newExpiryDate":"styles_newExpiryDate__3ayWm","footer":"styles_footer__1BZlZ"};